export const environment = {
  production: false,
  apiUrl: 'https://dev.markado.net/api/v1',
  supabase: {
    url: 'https://qqvugvfdybszcbykawpy.supabase.co',
    anonKey:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFxdnVndmZkeWJzemNieWthd3B5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA2NjMxNDAsImV4cCI6MjA3NjIzOTE0MH0.BM8O1ssk6wcFif1gUlU7C3w33v9oDFEmSV1SU7L-gms',
  },
  websocketUrl: 'https://dev.markado.net',
  recaptchaSiteKey: '6LdMKPIrAAAAAM2cjyPPXbEsgi3V-Y1imD0N_jfx',
  googleMapsApiKey: 'AIzaSyA0jlpTJQyhY8V01B_q8rAktGOz6-2doZs',
};
